import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { ITechSheet } from '../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';
import BlankNote from '../../common/BlankNote';

export interface ITechSheetItemProps {
  techSheet: ITechSheet;
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
}
class TechSheetItem extends React.Component<any> {

  constructor(props: any) {
    super(props);
  }

  render() {
    const className = `product-list-item product-list-img ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(this.props.isDragging!);
    return this.props.connectDragSource!(
      <li className={className}>
        {this.props.techSheet.image_path === 'note' ? <BlankNote blankFlag={false}/> : <img src={this.props.techSheet.image_path} title="" />}
      </li>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: props.techSheet,
      type: placeholderTypes.Blank,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(TechSheetItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/TechSheetItem.tsx